/**
 * Created by bscholl on 15.02.17.
 */
import {gsap} from 'gsap';

export default class AbstractTransition {

    protected _currentView: any;
    protected _nextView: any;
    protected _transitionCompleteCallback: any;
    protected _timeline: any;

    constructor(currentView, nextView) {

        this._currentView = currentView;
        this._nextView = nextView;
        this._transitionCompleteCallback = null;
        this._timeline = gsap.timeline({paused:true, onComplete:  ()  => this._onTransitionComplete()});
        this._createTransition();
    }

    _createTransition() {

       /* abstract function
       *
       * create yout timeline transition here
       *
       * */
       throw new Error('no transition defined');

    }

    _onTransitionComplete() {

        this._transitionCompleteCallback(this._nextView);
    }

    run(callback) {

        this._transitionCompleteCallback = callback;
        this._timeline.play();
    }

    destroy() {

        if(this._timeline) {
            this._timeline.pause();
            this._timeline.kill();
            this._timeline = null;
        }
    }

}
